import { createSelector } from "@reduxjs/toolkit";
import { CompanyMemberGroupsState } from "@store/company-member-groups/company-member-groups-slice";
import { RootState } from "@store/store-helper";

/**
 * Returns the groups for the provided company member group.
 */
export const companyMemberGroupsSelector: (
  state: RootState
) => CompanyMemberGroupsState["groups"] = createSelector(
  (state: RootState) => state,
  (state: RootState) => {
    return state.companyMemberGroups.groups;
  }
);

/**
 * Returns the fetching status of the company member group slice.
 */
export const companyMemberGroupsStatusSelector: (
  state: RootState
) => CompanyMemberGroupsState["status"] = createSelector(
  (state: RootState) => state,
  (state: RootState) => {
    return state.companyMemberGroups.status;
  }
);
